import React from 'react';
import { IconProps } from '../types';

const DocumentsIcon = ({
  width = '18px',
  height = '21px',
  color
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      fill={color}
      viewBox="0 0 18 21"
      version="1.1"
    >
      <g
        id="Full-Prototype-Spec"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Step-1---Risk-Profile"
          transform="translate(-27.000000, -92.000000)"
          fill="#FFFFFF"
          fillRule="nonzero"
        >
          <g id="Sidebar">
            <g id="Menu-Icons" transform="translate(24.000000, 58.000000)">
              <g id="Document-Icon" transform="translate(3.000000, 34.000000)">
                <path
                  d="M16.326383,3.00001423 L15.0036163,3.00001423 C14.9760501,3.00001423 14.9515495,3.00933281 14.925916,3.01543607 L14.925916,1.64810625 C14.925916,0.739265625 14.1577161,0 13.2132823,0 L1.7390836,0 C0.794650567,0 0.0264506333,0.739265625 0.0264506333,1.64810625 L0.0264506333,17.018564 C0.0264506333,17.9274041 0.794650567,18.6666704 1.73908393,18.6666704 L3.75131733,18.6666704 L3.75131733,19.4108246 C3.75131733,20.2871157 4.4900837,21 5.3984839,21 L16.3263836,21 C17.2347838,21 17.9735495,20.2871157 17.9735495,19.4108248 L17.9735495,4.58918913 C17.9735489,3.71289854 17.2347832,3.00001423 16.326383,3.00001423 Z M0.703683867,17.0185642 L0.703683867,1.64810625 C0.703683867,1.10709378 1.16831717,0.666684408 1.73908393,0.666684408 L13.2132826,0.666684408 C13.7840503,0.666684408 14.248683,1.10709378 14.248683,1.64810625 L14.248683,17.018564 C14.248683,17.5595765 13.7840503,18.0000188 13.2132826,18.0000188 L1.73908393,18.0000188 C1.16831717,18.0000189 0.703683867,17.5595766 0.703683867,17.0185642 Z M17.2962825,19.4108248 C17.2962825,19.9196161 16.8611158,20.3333484 16.326383,20.3333484 L5.3984833,20.3333484 C4.86374983,20.3333484 4.4285501,19.919616 4.4285501,19.4108248 L4.4285501,18.6666705 L13.2132816,18.6666705 C14.1577155,18.6666705 14.9259154,17.9274042 14.9259154,17.0185642 L14.9259154,3.65124365 C14.9515489,3.65734694 14.9760494,3.66666549 15.0036157,3.66666549 L16.3263823,3.66666549 C16.8611152,3.66666549 17.2962818,4.08039847 17.2962818,4.5891891 L17.2962818,19.4108248 L17.2962825,19.4108248 Z"
                  id="Shape"
                ></path>
                <path
                  d="M11.2010498,4.33334997 L3.75131733,4.33334997 C3.5641505,4.33334997 3.4126838,4.48241712 3.4126838,4.66665951 C3.4126838,4.85093441 3.5641505,5.0000016 3.75131733,5.0000016 L11.2010498,5.0000016 C11.3882166,5.0000016 11.539683,4.85093444 11.539683,4.66665951 C11.539683,4.48241712 11.3882167,4.33334997 11.2010498,4.33334997 Z"
                  id="Shape"
                ></path>
                <path
                  d="M11.2010498,7.0000221 L3.75131733,7.0000221 C3.5641505,7.0000221 3.4126838,7.14908926 3.4126838,7.33333102 C3.4126838,7.51757337 3.5641505,7.66667373 3.75131733,7.66667373 L11.2010498,7.66667373 C11.3882166,7.66667373 11.539683,7.5175734 11.539683,7.33333102 C11.539683,7.14908929 11.3882167,7.0000221 11.2010498,7.0000221 Z"
                  id="Shape"
                ></path>
                <path
                  d="M11.2010498,9.66666107 L3.75131733,9.66666107 C3.5641505,9.66666107 3.4126838,9.81576077 3.4126838,10.0000032 C3.4126838,10.1842455 3.5641505,10.3333452 3.75131733,10.3333452 L11.2010498,10.3333452 C11.3882166,10.3333452 11.539683,10.1842455 11.539683,10.0000032 C11.539683,9.81576077 11.3882167,9.66666107 11.2010498,9.66666107 Z"
                  id="Shape"
                ></path>
                <path
                  d="M7.81481617,12.3333326 L3.75131733,12.3333326 C3.5641505,12.3333326 3.4126838,12.4824323 3.4126838,12.6666747 C3.4126838,12.8509171 3.5641505,13.0000168 3.75131733,13.0000168 L7.81481613,13.0000168 C8.00198363,13.0000168 8.1534163,12.8509171 8.1534163,12.6666747 C8.1534163,12.4824323 8.00198363,12.3333326 7.81481617,12.3333326 Z"
                  id="Shape"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default DocumentsIcon;
